import AiTradeList from "../views/aiManagement/aiTradeList";
import AiChangeFaceStencil from "../views/aiManagement/aiChangeFaceStencil";
import AiChangeFaceList from "../views/aiManagement/aiChangeFaceList";
import AiChangeFaceImgList from "../views/aiManagement/aiChangeFaceImgList";
import AiImageToVideoList from "../views/aiManagement/aiImageToVideoList";
import AiTemplate from "../views/aiManagement/AiTemplate";
import AIDrawList from "../views/aiManagement/AIDrawList";
import Main from "../views/main";
const AiRouter = {
  path: "/aiModule",
  component: Main,
  title: "AI管理",
  icon: "el-icon-sort",
  meta: { keepAlive: true },
  children: [
    {
      path: "/ai-template",
      component: AiTemplate,
      name: "AiTemplate",
      title: "AI模版模块列表",
      meta: { title: "AI模版模块列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-stencil",
      component: AiChangeFaceStencil,
      name: "aiChangeFaceStencil",
      title: "AI模版列表",
      meta: { title: "AI模版列表", keepAlive: true },
    },
    {
      path: "/ai-trade-list",
      component: AiTradeList,
      name: "aiTradeList",
      title: "AI脱衣交易列表",
      meta: { title: "AI脱衣交易列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-list",
      component: AiChangeFaceList,
      name: "aiChangeFaceList",
      title: "AI换脸交易列表",
      meta: { title: "AI换脸交易列表", keepAlive: true },
    },
    {
      path: "/ai-change-face-img-list",
      component: AiChangeFaceImgList,
      name: "aiChangeFaceImgList",
      title: "AI图片换脸交易列表",
      meta: { title: "AI图片换脸交易列表", keepAlive: true },
    },
    {
      path: "/ai-image-to-video-list",
      component: AiImageToVideoList,
      name: "AiImageToVideoList",
      title: "AI图生视频列表",
      meta: { title: "AI图生视频列表", keepAlive: true },
    },
    {
      path: "/ai-draw-list",
      component: AIDrawList,
      name: "AiImageToVideoList",
      title: "AI绘图列表",
      meta: { title: "AI绘图列表", keepAlive: true },
    },
  ],
};
export default AiRouter;
